/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Ws_S1Inputs */

const en_mk_tut_ws_s1 = /** @type {(inputs: Mk_Tut_Ws_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type your company name. The address (slug) and issue prefix fill themselves in — a company called *Dapur Nusa* gets issue numbers \`DN-1\`, \`DN-2\` and so on.`)
};

const id_mk_tut_ws_s1 = /** @type {(inputs: Mk_Tut_Ws_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Isi nama perusahaan. Alamat (slug) dan awalan nomor issue terisi otomatis — misalnya perusahaan *Dapur Nusa* mendapat nomor issue \`DN-1\`, \`DN-2\`, dan seterusnya.`)
};

/**
* | output |
* | --- |
* | "Type your company name. The address (slug) and issue prefix fill themselves in — a company called *Dapur Nusa* gets issue numbers `DN-1`, `DN-2` and so on." |
*
* @param {Mk_Tut_Ws_S1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_ws_s1 = /** @type {((inputs?: Mk_Tut_Ws_S1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Ws_S1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_ws_s1(inputs)
	return en_mk_tut_ws_s1(inputs)
});